import React, { FunctionComponent, useState } from 'react';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';

import { useDispatch } from 'store';
import trainingEffects from 'store/effects/training.effects';
import TrainingService from 'services/training.service';

import ScreenWrapper from 'application/components/screen-wrapper';
import LoadingBar from 'application/components/loading-bar';

import ApplyModifiersContainer from '../../containers/apply-summary.container';
import { GetApplyModifiersSummaryFormValues, ApplyModifiers } from '../../forms/apply-profiles.form/types';
import ApplyModifiersForm from '../../forms/apply-profiles.form/apply-modifiers.form';

const Title = styled.div`
  font-size: 20px;
  font-weight: 500;
  opacity: 0.9;
  padding: 12px;
`;

const ApplyModifiersScreen: FunctionComponent = () => {
  const dispatch = useDispatch();

  const loading = TrainingService.useIsLoading();

  const [farmId, setFarmId] = useState<string | undefined>();
  const [trainingsToBeApplied, setTrainingsToBeApplied] = useState<ApplyModifiers | undefined>();

  const handleSubmit = async (values: GetApplyModifiersSummaryFormValues) => {
    await dispatch(trainingEffects.fetchAppliedModifiers(values));

    setTrainingsToBeApplied(values.trainings);
    setFarmId(values.farmId);
  };

  return (
    <>
      <LoadingBar loading={loading} />
      <ScreenWrapper>
        <Grid item xs={12} sm={10} lg={8}>
          <Title>Apply modifiers</Title>
          <ApplyModifiersForm
            onSubmit={handleSubmit}
            onChange={() => setTrainingsToBeApplied(undefined)}
            disableSubmit={trainingsToBeApplied != null}
          />
          {trainingsToBeApplied && farmId && (
            <ApplyModifiersContainer farmId={farmId} modifiersToApply={trainingsToBeApplied} />
          )}
        </Grid>
      </ScreenWrapper>
    </>
  );
};

export default ApplyModifiersScreen;
